import { Button } from "react-bootstrap";

export function EntryPick(props) {
    if (!props.game) {
        return <></>;
    }

    const game = props.game;
    const pick = props.pick;
    const gameInProgress = Date.parse(game.start_time) < Date.now() && game.home_points === undefined
    let variant = 'outline-secondary';
    if (gameInProgress) {
        variant = 'outline-warning';
    } else if (pick.status === 'LOSS') {
        variant = 'outline-danger';
    } else if (pick.status === 'WIN') {
        variant = 'outline-success';
    }

    let buttonText;
    if (pick.home_team) {
        buttonText = '@' + game.home_team + ' ' + game.home_spread;
    } else {
        buttonText = game.away_team + ' ' + -game.home_spread;
    }

    return (
        <td className="align-middle">
            <Button variant={variant}>{buttonText}</Button>
        </td>
    );
}